"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLink = exports.Links = exports.Inner = exports.CopyrightTitle = void 0;
var _mui = require("@ori-ui/mui");
var _constants = require("../../constants");
const StyledLink = exports.StyledLink = (0, _mui.styled)(_mui.Link)(({
  theme
}) => ({
  display: 'inline-block',
  textDecoration: 'underline'
}));
const Inner = exports.Inner = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(2),
  [theme.breakpoints.up('sm')]: {
    gap: theme.spacing(1)
  }
}));
const Links = exports.Links = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(4)
}));
const CopyrightTitle = exports.CopyrightTitle = (0, _mui.styled)(_mui.Typography)(() => ({
  maxWidth: _constants.maxTextWidth
}));